function Interests() {
         return (
             <section className="interests card card--container">
                 <h2 className="interests-title">Interests</h2>
                 <p className="interests-info">Chess. Reader. Internet fanatic. Coding. Movie geek. Pop culture ninja. Coffee fanatic.</p>
             </section>
         )
     }
     export default Interests;